import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "./ThemeContext";

/**
 * Msg 247 · header toggle. Sun in dark mode (tap to go light), Moon in light
 * mode (tap to go dark). Sits in the top-right of the member header, where
 * the like icon used to be.
 */
export default function ThemeToggle({ size = 22 }) {
  const { theme, toggle } = useTheme();
  const isCream = theme === "cream";
  const Icon = isCream ? Moon : Sun;
  return (
    <button
      type="button"
      aria-label={isCream ? "switch to dark mode" : "switch to light mode"}
      data-testid="topbar-theme-toggle"
      onClick={toggle}
      className="p-2"
      style={{ background: "transparent", border: 0, cursor: "pointer",
               color: "var(--ww-text)", display: "grid", placeItems: "center" }}>
      <Icon size={size} strokeWidth={1.6} />
    </button>
  );
}
